<div class="border-[1.5px] border-solid border-[#F2F4F7] rounded-[10px] bg-white p-3 md:p-5"
  *transloco="let t; currentLang as currentLang">
  @if(showRequirements()){
  <p id="requirementsSection" class="text-[#0E73A9] text-base font-semibold mb-3 md:mb-4">{{t('requirements')}}</p>
  @if(jobDetails()?.EducationRequirements){
  <div class="mb-4 md:mb-4">
    <p class="mb-3 text-sm font-medium text-[#101828]">{{t('Education')}}</p>
    <ul class="list-disc pl-5 md:px-6 leading-7 text-xs sm:text-sm text-[#344054]">
      @for (item of detailsUtilService.getFormattedList(jobDetails()?.EducationRequirements ?? '');
      track $index) {
      <li class="leading-7" appHighlight [searchText]="keyword()">{{item}}</li>
      }
    </ul>
  </div>
  }

  @if(jobDetails()?.experience && jobDetails()?.experience !== '--'){
  <div class="mb-4 md:mb-4 text-[#333]">
    <p class="font-medium text-sm mb-3 text-[#101828]">{{t('experiences')}}</p>
    <ul class="list-disc px-6 text-[#344054]">
      <li appHighlight [searchText]="keyword()" class="sm:leading-6 leading-7 text-xs sm:text-sm"
        [innerHTML]="experience()">
      </li>

      @if(jobDetails()?.experienceBusinessArea){
      <li appHighlight [searchText]="keyword()" class="sm:leading-6 leading-7 text-xs sm:text-sm">
        <p>The applicants should have experience in the following business area(s):</p>
        <div
          class="my-2 flex items-center flex-wrap gap-2.5 text-[#333] text-xs sm:text-sm font-normal leading-7 m-0 box-border">
          @for(item of experienceBusinessArea(); track $index){
          <button appHighlight [searchText]="keyword()"
            class="cursor-default text-[10px] sm:text-xs bg-[#F8F9FC] text-[#363F72] font-medium border border-[#D5D9EB] rounded-full px-2 py-0.5 sm:px-2.5 sm:py-1">
            {{item}}
          </button>
          }
        </div>
      </li>
      }

      @if(jobDetails()?.fresher){
      <li class="sm:leading-6 leading-7 text-xs sm:text-sm">{{jobDetails()?.fresher}}</li>
      }

  @if(addExperienceParsed().chips.length){
  <li appHighlight [searchText]="keyword()" class="sm:leading-6 leading-7 text-xs sm:text-sm">
    @if(addExperienceParsed().label){ <p>{{addExperienceParsed().label}}</p> }
  <div
    class="my-2 flex items-center flex-wrap gap-2.5 text-[#333] text-xs sm:text-sm font-normal leading-7 m-0 box-border">
    @for(item of addExperienceParsed().chips; track $index){
    <button appHighlight [searchText]="keyword()"
      class="cursor-default text-[10px] sm:text-xs leading-none bg-[#F8F9FC] text-[#363F72] font-medium border border-[#D5D9EB] rounded-full px-2 py-[6px] sm:px-2.5 sm:py-1">
      {{item}}
    </button>
    }
  </div>
  </li>
  }
  
  @for(plain of addExperienceParsed().plainItems; track $index){
  <li appHighlight [searchText]="keyword()" class="sm:leading-6 leading-7 text-xs sm:text-sm">{{plain}}</li>
  }
    </ul>
  </div>
  }
  @if(jobDetails()?.AdditionJobRequirements){
  <div class="">
    <p class="text-sm font-medium text-[#101828] mb-3" id="req">{{t('addReq')}}</p>
    <div class="px-0  sm:leading-7 leading-5 sm:text-sm text-xs text-[#344054]" appHighlight [searchText]="keyword()"
      [innerHTML]="sharedService.sanitizeCardProperties(jobDetails()?.AdditionJobRequirements)"></div>
  </div>
  }

  <div class="bg-[#E4E7EC] w-full my-3 md:my-4 h-[1px]"></div>
  }
  @if(jobDetails()?.JobDescription){
  <div id="responsibilitiesSection" class="">
    <p class="text-[#0E73A9] text-base font-semibold mb-3" id="job_resp">
      {{t('res_context')}}
    </p>
    <div class="mb-5 leading-7">
      <div appHighlight [searchText]="keyword()" class="text-xs sm:text-sm text-[#344054] sm:leading-7 leading-5"
        [innerHTML]="responsibilities()">
      </div>
    </div>
    <div class="bg-[#E4E7EC] w-full my-3 md:my-4 h-[1px]"></div>
  </div>
  }

  @if( jobDetails()?.SkillsRequired || jobDetails()?.SuggestedSkills){
  <p id="skillsSection" class="text-[#0E73A9] text-base font-semibold mb-4">{{t('skills_req')}}</p>
  @if(jobDetails()?.SkillsRequired){
  <div
    class="flex items-center flex-wrap gap-2.5 text-[#333] text-xs sm:text-sm font-normal leading-[1.42857143] m-0 box-border">
    @for(skill of skillsArray(); track $index){
    <button appHighlight [searchText]="keyword()"
      class="cursor-default text-[10px] sm:text-xs bg-[#F9FAFB] text-secondary font-medium border border-[#E4E7EC] rounded-full px-2 py-0.5 sm:px-2.5 sm:py-1">
      {{skill}}
    </button>
    }
  </div>
  }

  @if(jobDetails()?.SuggestedSkills){
  <div class="p-2 md:px-3 md:py-2.5  rounded-lg border border-[#E4E7EC] bg-[#F9FAFB] mt-4">
    <p class="flex items-center gap-2 mb-3">
      <span class="text-sm text-[#101828] font-medium">{{t('otherRelevantSkills')}}</span>
    </p>

    <div
      class="flex items-center flex-wrap gap-2.5 text-[#333] text-xs sm:text-sm font-normal leading-[1.42857143] m-0 box-border">
      @for(skill of suggestedSkills(); track $index){
      <button appHighlight [searchText]="keyword()"
        class="cursor-default text-[10px] sm:text-xs bg-[#F9FAFB] text-secondary border border-[#E4E7EC] rounded-full px-2 py-0.5 sm:px-2.5 sm:py-1">
        {{skill}}
      </button>
      }
    </div>
  </div>
  }
  <div class="bg-[#E4E7EC] w-full my-3 md:my-4 h-[1px]"></div>
  }

  @if(hasCompensationSection()){
  <div id="salarySection" class="sm:text-sm text-[#333]">
    <p class="text-[#0E73A9] font-semibold text-sm sm:text-base mb-3">{{t('comp_ben')}}</p>

    @if (compensationAndBenefits().length) {
    <div class="mb-4 md:mb-5">
      <p class="mb-3 text-sm font-medium text-[#101828]">{{t('com_ben_title')}}:</p>
      <div
        class="flex items-center flex-wrap gap-2.5 text-xs sm:text-sm font-normal leading-[1.42857143] m-0 box-border">
        @for (item of compensationAndBenefits(); track $index) {
        <button appHighlight [searchText]="keyword()"
          class="cursor-default text-[10px] sm:text-xs bg-[#F9FAFB] text-secondary font-medium border border-[#E4E7EC] rounded-full px-2 py-0.5 sm:px-2.5 sm:py-1">
          {{item}}
        </button>
        }
      </div>
      <div class="bg-[#E4E7EC] w-full my-3 md:my-4 h-[1px]"></div>
    </div>
    }

    @if (lunchFacility()) {
    <div class="mb-3 flex flex-col gap-1 md:flex-row md:items-center md:gap-2">
      <p class="text-xs font-medium text-[#101828] sm:text-sm">Lunch Facility:</p>
      <p appHighlight [searchText]="keyword()" class="text-xs text-[#344054] sm:text-sm">
        {{lunchFacility()}}
      </p>
    </div>
    }

    @if (salaryReview()) {
    <div class="mb-3 flex flex-col gap-1 md:flex-row md:items-center md:gap-2">
      <p class="text-xs font-medium text-[#101828] sm:text-sm">Salary Review:</p>
      <p appHighlight [searchText]="keyword()" class="text-xs text-[#344054] sm:text-sm">
        {{salaryReview()}}
      </p>
    </div>
    }

    @if (festivalBonus()) {
    <div class="mb-3 flex flex-col gap-1 md:flex-row md:items-center md:gap-2">
      <p class="text-xs font-medium text-[#101828] sm:text-sm">Festival Bonus:</p>
      <p appHighlight [searchText]="keyword()" class="text-xs text-[#344054] sm:text-sm">
        {{festivalBonus()}}
      </p>
    </div>
    <div class="bg-[#E4E7EC] w-full my-3 md:my-4 h-[1px]"></div>
    }
  </div>
  }

  @if (jobDetails()?.JobWorkPlace) {
  <div class="pt-3 md:pt-0 text-sm text-[#333] flex flex-col gap-0.5">
    <p class="text-[#101828] font-medium text-xs sm:text-sm">{{t('workplace')}} :</p>
    <p data-testid="job-workplace" class="text-xs sm:text-sm font-normal text-[#344054]">
      {{ jobDetails()?.JobWorkPlace === 'Home' ? 'Work from home' : jobDetails()?.JobWorkPlace }}
    </p>
  </div>
  }

  @if(jobDetails()?.JobNature){
  <div class="pt-2.5 text-sm text-[#333] flex flex-col gap-0.5">
    <p class="text-[#101828] font-medium text-xs sm:text-sm">{{t('emp_status')}} :</p>
    <p class="text-xs sm:text-sm font-normal text-[#344054]">
      {{jobDetails()?.JobNature}}
    </p>
  </div>
  }

  @if(gender()){
  <div class="pt-2.5 text-sm text-[#333] flex flex-col gap-0.5">
    <p class="text-[#101828] font-medium text-xs sm:text-sm">{{t('gender')}} :</p>
    <p class="text-xs sm:text-sm font-normal text-[#344054]">
      {{gender() | transloco}}</p>
  </div>
  }

@if(jobDetails()?.JobLocation){
<div id="jobLocationSection" class="pt-2.5 text-sm text-[#333] flex flex-col gap-0.5">
  <p class="text-[#101828] font-medium text-sm sm:text-sm">{{t('jobLocation')}} :</p>
  <p class="text-xs sm:text-sm font-normal text-[#344054]">
    {{jobDetails()?.JobLocation}}</p>
</div>
}

</div>